module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.hLoading),
      expression: "hLoading"
    }],
    staticClass: "gTopMg gPageBorder"
  }, [_c('el-table', {
    ref: "arrdata",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": _vm.$t('lin_global.name')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "version",
      "label": _vm.$t('lin_global.version'),
      "width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('lin_global.status'),
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.status == 0) ? _c('span', {
          staticStyle: {
            "color": "#8492A6"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitOne')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 1) ? _c('span', {
          staticStyle: {
            "color": "#F7BA2A"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.waitTwo')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 2) ? _c('span', {
          staticStyle: {
            "color": "#13CE66"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyPass')))]) : _vm._e(), _vm._v(" "), (scope.row.status == 3) ? _c('span', {
          staticStyle: {
            "color": "#FF4949"
          }
        }, [_vm._v(_vm._s(_vm.$t('lin_global.verifyNotPass')))]) : _vm._e(), _vm._v(" "), (scope.row.ifInfor) ? _c('el-popover', {
          attrs: {
            "trigger": "hover",
            "placement": "top"
          }
        }, [_c('p', [_vm._v(_vm._s(scope.row.auditContent))]), _vm._v(" "), _c('span', {
          staticClass: "name-wrapper",
          attrs: {
            "slot": "reference"
          },
          slot: "reference"
        }, [(scope.row.ifInfor) ? _c('el-icon', {
          staticStyle: {
            "cursor": "pointer",
            "color": "#58B7FF"
          },
          attrs: {
            "name": "information"
          }
        }) : _vm._e()], 1)]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "type",
      "label": _vm.$t('terminal.details.animatType'),
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('label', [_vm._v(_vm._s(_vm.otaUdType(scope.row.updateType)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mechanismName",
      "label": _vm.$t('lin_global.label_areaid')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "size",
      "label": _vm.$t('app_fileSize'),
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": _vm.$t('lin_global.ope'),
      "width": "106"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return undefined
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gPgDiv"
  }, [_c('el-pagination', {
    staticClass: "gPg",
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 50, 100],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.totalRecords
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-946211ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/romPush.vue
// module id = 1100
// module chunks = 0